import { handleActions, combineActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = false

export default handleActions(
  {
    [rawActions.trainProject.request](state, { payload }) {
      return true
    },
    [combineActions(rawActions.trainProject.failed, rawActions.trainProject.success)](state, { payload }) {
      return false
    },
  },
  defaultState
)
